export default "__VITE_ASSET__BTRzK2JU__"